import React, { useEffect, useRef, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import { Button, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import PopUp from "layouts/super-admin/Accounts/components/Tabs/Component/PopUp";
import { useUploadImage } from "hook/services";
import Quill from "quill";
import "quill/dist/quill.snow.css";
const { v4: uuidv4 } = require("uuid");
import eyeIcon from "../../../../../assets/themeIcons/eye-view.svg";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import PrimaryButton from "../../../components/PrimaryButton";
import "../../../Accounts/components/Tabs/accountDetailTabs.css";

function Events({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);
  const [businesses, setBusinesses] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState("");
  const { id } = useParams();
  const [eventsData, setEventsData] = useState([]);
  const [agency] = useAgencyInfo();

  const navigate = useNavigate();
  const uploadImage = useUploadImage();

  const getEvents = async () => {
    const { response } = await AppService.events.Get({
      query: `account_id=${formData._id}&include_past=true`,
    });
    if (response) {
      setEventsData(response.data); // Assuming API returns a list of events
    }
  };

  const [currentFormData, setCurrentFormData] = useState({
    event_name: "",
    event_date: "",
    event_description: "",
    event_start_time: "",
    event_end_time: "",
    event_location: "",
  });

  useEffect(() => {
    const fetchBusinesses = async () => {
      if (!id) {
        setBusinesses([]);
        return;
      }
      try {
        const { response } = await AppService.claim_business.Get({
          query: `account_id=${id}&status=approved`,
        });
        const list = Array.isArray(response?.data) ? response.data : [];
        setBusinesses(list);
      } catch (error) {
        console.error("Error fetching businesses:", error);
        setBusinesses([]);
      }
    };
    fetchBusinesses();
  }, [id]);

  const [applicantsPopup, setApplicantsPopup] = useState(false);
  const [applicants, setApplicants] = useState([]);

  const closeApplicantsPopup = () => setApplicantsPopup(false);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedEvent(null);
    quillInstance.current = null;
    setCurrentFormData({
      event_name: "",
      event_date: "",
      event_description: "",
      event_start_time: "",
      event_end_time: "",
      event_location: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!selectedBusiness) {
      setSuccess("Please select a business to add an event.");
      return;
    }

    const image = e.target.image.files[0];
    let image_url = selectedEvent?.image || "";

    if (image) {
      const image_response = await uploadImageToGhl(image, agency);
      image_url = image_response?.data;

      if (image_response?.data) {
        toast.success("Image Uploaded Successfully");
      } else {
        toast.error("Error updating Image");
      }
    }

    const descriptionHtml =
      quillInstance.current?.root?.innerHTML?.trim() ||
      currentFormData.event_description ||
      "";

    const payload = {
      event_name: currentFormData.event_name,
      event_date: currentFormData.event_date,
      event_description: descriptionHtml,
      event_start_time: currentFormData.event_start_time,
      event_end_time: currentFormData.event_end_time,
      event_location: currentFormData.event_location,
      image: image_url,
      account_id: formData._id,
      agency_id: formData.agency_id,
    };

    let response;

    if (selectedEvent) {
      // Update event
      response = await AppService.events.Update({
        payload: { ...payload, _id: selectedEvent._id }, // Include _id for update
      });
    } else {
      // Create new event
      response = await AppService.events.Create({ payload });
    }

    if (response) {
      handleRefresh();
      toast.success(
        selectedEvent ? "Event updated successfully!" : "New event created successfully!"
      );
      closePopup();
      setSelectedEvent(null);
      getEvents(); // Refresh events after update/create
      closePopup();
    } else {
      toast.error("Please select a business");
    }
    setLoading(false);
  };

  const handleEdit = (event) => {
    setSelectedEvent(event); // Set the selected event for editing
    setCurrentFormData({
      event_name: event.event_name,
      event_date: event.event_date,
      event_description: event.event_description,
      event_start_time: event.event_start_time,
      event_end_time: event.event_end_time,
      event_location: event.event_location,
      image: event.image,
      account_id: selectedBusiness,
      agency_id: formData.agency_id,
    });
    openPopup();
  };

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      const { response } = await AppService.events.Delete({
        query: `_id=${event._id}`, // ✅ Send event ID for deletion
      });

      if (response) {
        handleRefresh();
        setSuccess("Event deleted successfully!");
        getEvents();
      }
    } catch (error) {
      console.error("Error deleting event:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEvent) {
      setCurrentFormData({
        event_name: selectedEvent.event_name,
        event_date: selectedEvent.event_date,
        event_description: selectedEvent.event_description,
        event_start_time: selectedEvent.event_start_time,
        event_end_time: selectedEvent.event_end_time,
        event_location: selectedEvent.event_location,
        image: selectedEvent?.image,
      });
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (!popup) {
      if (quillInstance.current) {
        quillInstance.current = null;
      }
      return;
    }
    const timer = setTimeout(() => {
      if (quillRef.current && !quillInstance.current) {
        quillInstance.current = new Quill(quillRef.current, {
          theme: "snow",
          placeholder: "Event description...",
          modules: {
            toolbar: [
              [{ header: [1, 2, 3, false] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              ["link", "image"],
              ["clean"],
            ],
          },
        });
      }
      if (quillInstance.current) {
        const html =
          selectedEvent?.event_description || currentFormData?.event_description || "";
        quillInstance.current.root.innerHTML = html;
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [popup, selectedEvent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setSuccess("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setCurrentFormData((prevData) => ({
      ...prevData,
      image: file,
    }));
  };

  return (
    <div className="sd-account-detail-tab">
      <p className="text-center">{success}</p>

      <SoftBox>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
            <p style={{ flex: 1, fontSize: "16px" }}>
              {!businesses.length && "There is no Business against this event"}
            </p>

            <PrimaryButton
              showPlus
              type="button"
              onClick={openPopup}
              disabled={!businesses.length}
            >
              Add Event
            </PrimaryButton>
          </Grid>

          <Grid item xs={12}>
            <div
              className="d-flex justify-content-between"
              style={{
                margin: "10px 0px",
                padding: "20px",
                borderRadius: "18px",
                background: "#F7F7F7",
              }}
            >
              <p style={{ flex: 1, fontWeight: 600 }}>Name</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Date</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Start Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>End Time</p>
              <p style={{ flex: 1, fontWeight: 600 }}>Action</p>
            </div>

            {eventsData?.map((event, index) => (
              <div
                className="d-flex justify-content-between"
                style={{
                  margin: "20px 0",
                  padding: "15px 10px",
                  borderBottom: "1px solid",
                  borderColor: "#DDDDDD",
                }}
                key={index}
              >
                <p style={{ flex: 1 }}>{event?.event_name}</p>
                <p style={{ flex: 1 }}>{event?.event_date}</p>
                <p style={{ flex: 1 }}>{event?.event_start_time}</p>
                <p style={{ flex: 1 }}>{event?.event_end_time}</p>

                <div
                  style={{ flex: 1, display: "flex", justifyContent: "flex-start", gap: "20px" }}
                >
                  <img
                    onClick={() =>
                      navigate(`../event-detail/${event._id}`, {
                        state: { event, applicants: event?.interested_users || [] },
                      })
                    }
                    width={25}
                    src={eyeIcon}
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    onClick={() => handleEdit(event)}
                    disabled={loading}
                    width={20}
                    src={editIcon}
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    onClick={() => handleDelete(event)}
                    disabled={loading}
                    width={20}
                    src={deleteIcon}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            ))}
          </Grid>
        </Grid>
      </SoftBox>

      <PopUp
        open={popup}
        handleClose={closePopup}
        title={selectedEvent ? "Edit Event" : "New Event"}
      >
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "0px 10px 0px 10px", width: "50%" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Select Business</label>
              <select
                className="form-control-agust"
                value={selectedBusiness}
                onChange={(e) => setSelectedBusiness(e.target.value)}
                disabled={loading} // Disable dropdown while loading
                style={{ padding: "15px" }}
              >
                <option value="" disabled>
                  -- Select a Business --
                </option>
                {businesses.map((business, index) => (
                  <option key={index} value={business?.business_id}>
                    {business?.business_name}
                  </option>
                ))}
              </select>
            </SoftBox>
          </div>

          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Name</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Name"
                  name="event_name"
                  value={currentFormData.event_name}
                  disabled={loading} // Disable input while loading
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Date</label>
                <input
                  type="date"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Date"
                  name="event_date"
                  value={currentFormData.event_date}
                  disabled={loading} // Disable input while loading
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Event Location</label>
                <input
                  type="text"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Event Location"
                  name="event_location"
                  value={currentFormData.event_location}
                  disabled={loading} // Disable input while loading
                />
              </SoftBox>
            </div>
          </div>

          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className=" text-black">Start Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="Start Time"
                  name="event_start_time"
                  value={currentFormData.event_start_time}
                  disabled={loading}
                />
              </SoftBox>
            </div>
            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">End Time</label>
                <input
                  type="time"
                  className="form-control-agust"
                  onChange={handleChange}
                  placeholder="End Time"
                  name="event_end_time"
                  value={currentFormData.event_end_time}
                  disabled={loading}
                />
              </SoftBox>
            </div>

            <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Image</label>
                <input
                  className="form-control-agust"
                  name="image"
                  type="file"
                  onChange={handleImageChange}
                />
              </SoftBox>
            </div>
          </div>

          <div style={{ padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Event Description</label>
              <div
                ref={quillRef}
                className="sd-account-detail-tab__quill editor"
                style={{ minHeight: "220px", background: "#fff" }}
              />
            </SoftBox>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "0 10px 10px",
            }}
          >
            <PrimaryButton type="submit" disabled={loading}>
              {selectedEvent ? "Update Event" : "Add Event"}
            </PrimaryButton>
          </div>
        </form>
      </PopUp>

      <PopUp
        open={applicantsPopup}
        handleClose={closeApplicantsPopup}
        title="Intrested Persons"
        style={{ with: "70%" }}
      >
        <div
          style={{ padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", with: "70%" }}
        >
          {applicants.length > 0 ? (
            <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
              {applicants.map((applicant, index) => (
                <li
                  key={index}
                  style={{
                    padding: "12px",
                    margin: "8px 0",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    Name: {applicant?.first_name} {applicant?.last_name}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#555",
                    }}
                  >
                    Business Name: {applicant?.business_name}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p
              style={{
                fontSize: "14px",
                color: "#999",
                textAlign: "center",
              }}
            >
              No one is interested in this event.
            </p>
          )}
        </div>
      </PopUp>
    </div>
  );
}

export default Events;
